export default function PropertyContractList() {
  return <div>hello word </div>;
}
